export const licenseTermsPageTranslationsPl = {
    licenseTermsAdd: 'Dodaj warunki licencji',
    licenseTermsUpdate: 'Aktualizuj warunki licencji',
    licenseTermsPage: 'Warunki licencji',
    licenseTermsNote: 'Notatki',
    licenseTermsDelete: 'Usuń warunki licencji',
    licenseTermsRemoveConfirmationMessage: 'Czy na pewno chcesz usunąć wybrane warunki licencji?',
    licenseTermsNotes: 'Notatki',
    licenseTermsStartDate: 'Ważne od',
    licenseTermsEndDate: 'Ważne do',
    fileNotChoosen: 'Plik nie został wybrany',
    licenceTermsLicenseType: 'Typ licencji',
};

export const licenseTermsPageTranslationsEn = {
    licenseTermsAdd: 'Add license terms',
    licenseTermsUpdate: 'Update license terms',
    licenseTermsPage: 'License Terms',
    licenseTermsNote: 'Notes',
    licenseTermsDelete: 'Delete license terms',
    licenseTermsRemoveConfirmationMessage: 'Are you sure you want to delete the selected license terms?',
    licenseTermsNotes: 'Notes',
    licenseTermsStartDate: 'Valid from',
    licenseTermsEndDate: 'Valid to',
    fileNotChoosen: '(file not choosen)',
    licenceTermsLicenseType: 'License type',
};
